let prevScrollpos = window.scrollY
export function initializeHeaderNavigation() {
  const root: HTMLElement | null = document.getElementsByTagName('html')[0]
  const header: HTMLElement | null = document.querySelector('.header')
  const searchbar = document.getElementById('searchbar')
  const primaryMenuItems: NodeListOf<Element> = document.querySelectorAll('.header__menu-primary')
  const primaryMenuItemsMobile: NodeListOf<Element> = document.querySelectorAll(
    '.header__menu-item--mobile',
  )
  const primaryMenuMobile: HTMLElement | null = document.querySelector(
    '.header__navigation--mobile',
  )
  const secondaryMenuItems: NodeListOf<Element> = document.querySelectorAll(
    '.header__navigation-secondary',
  )
  const secondaryMenuButtons: NodeListOf<Element> = document.querySelectorAll(
    '.header__menu-item-button-icon',
  )
  const burgerButton: HTMLElement | null = document.querySelector('.header__burger')
  const menuItemsDesktop: NodeListOf<Element> = document.querySelectorAll(
    '.header__menu-item--desktop',
  )
  const tertiaryLinks: NodeListOf<Element> = document.querySelectorAll('.header__tertiary-links')
  const headerSecondaryLinks: HTMLElement | null = document.querySelector(
    '.header__bar-secondary-links',
  )
  let hoverIntentTimer: ReturnType<typeof setTimeout> | undefined
  let resizeTimer: ReturnType<typeof setTimeout>
  let isDesktop = window.matchMedia('(min-width: 1040px)').matches

  const searchHidden = new CustomEvent('searchbar-is-visible', {
    detail: false,
  })
  const searchVisible = new CustomEvent('searchbar-is-visible', {
    detail: true,
  })

  const toggleNavigation = () => {
    header?.classList.toggle('menu-active')
    root?.classList.toggle('menu--is-open')
    primaryMenuMobile?.classList.toggle('is-active')

    if (
      header?.classList.contains('menu-active') ||
      root?.classList.contains('search--is-hidden')
    ) {
      window.dispatchEvent(searchHidden)
    } else {
      window.dispatchEvent(searchVisible)
    }
    window.dataLayer?.push({ event: 'navigationActive' })

    primaryMenuItems.forEach((menuItem) => {
      menuItem.classList.remove('is-active')
    })
    primaryMenuMobile?.classList.remove('is-hidden')
  }

  const activateMenuItem = (menuItem: Element) => {
    window.dispatchEvent(searchHidden)
    window.dataLayer?.push({ event: 'navigationActive' })

    menuItemsDesktop.forEach((item) => item.classList.remove('is-active'))
    menuItem.classList.add('is-active')
    header?.classList.add('menu-active')
    root?.classList.add('menu--is-open')
  }

  const deactivateMenuItem = (menuItem: Element) => {
    window.dispatchEvent(searchVisible)
    menuItem.classList.remove('is-active')
    header?.classList.remove('menu-active')
    root?.classList.remove('menu--is-open')
    secondaryMenuItems.forEach((item) => item.classList.remove('is-active'))
    tertiaryLinks.forEach((tertiaryLink) => tertiaryLink.classList.remove('is-active'))
  }

  const handleMenuItemHover = (menuItem: Element, index: number) => {
    clearTimeout(hoverIntentTimer)
    hoverIntentTimer = setTimeout(() => {
      activateMenuItem(menuItem)
      tertiaryLinks.forEach((tertiaryLink) => tertiaryLink.classList.remove('is-active'))
      tertiaryLinks[index].classList.add('is-active')
    }, 100)
  }

  const debounce = (callback: () => void, delay: number) => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(callback, delay)
  }

  const handleMouseLeave = (event: Event) => {
    clearTimeout(hoverIntentTimer)
    deactivateMenuItem(event.target as HTMLElement)
  }

  const resetNavigation = () => {
    isDesktop = window.matchMedia('(min-width: 1040px)').matches
    primaryMenuMobile?.classList.remove('is-active')
    primaryMenuMobile?.classList.remove('is-hidden')

    header?.classList.remove('menu-active')
    root?.classList.remove('menu--is-open')
    primaryMenuItems.forEach((menuItem) => {
      menuItem.classList.remove('is-active')
    })
    primaryMenuItems.forEach((menuItem) => {
      menuItem.removeEventListener('mouseleave', handleMouseLeave)
      if (isDesktop) {
        menuItem.addEventListener('mouseleave', handleMouseLeave)
      }
    })
  }

  const handleScroll = () => {
    const currentScrollPos = window.scrollY
    const tolerance = 300

    currentScrollPos != 0
      ? root?.classList.add('has-scrolled')
      : root?.classList.remove('has-scrolled')

    if (!searchbar) return
    if (currentScrollPos > tolerance) {
      if (prevScrollpos >= currentScrollPos) {
        root?.classList.remove('search--is-hidden')
        window.dispatchEvent(searchVisible)
      } else {
        root?.classList.add('search--is-hidden')
        window.dispatchEvent(searchHidden)
      }
    }
    prevScrollpos = currentScrollPos
  }

  burgerButton?.addEventListener('click', toggleNavigation)

  primaryMenuItemsMobile.forEach((menuItemMobile, index) => {
    menuItemMobile.addEventListener('click', () => {
      primaryMenuItems.forEach((menuItem) => menuItem.classList.remove('is-active'))
      primaryMenuItems[index].classList.add('is-active')
      primaryMenuMobile?.classList.add('is-hidden')
    })
  })

  secondaryMenuButtons.forEach((secondaryMenuButton) => {
    secondaryMenuButton.addEventListener('click', () => {
      primaryMenuMobile?.classList.add('is-active')
      primaryMenuMobile?.classList.remove('is-hidden')
      primaryMenuItems.forEach((menuItem) => menuItem.classList.remove('is-active'))
    })
  })

  menuItemsDesktop.forEach((menuItem, index) => {
    menuItem.addEventListener('mouseenter', () => handleMenuItemHover(menuItem, index))
    menuItem.addEventListener('mouseleave', () => clearTimeout(hoverIntentTimer))
  })

  secondaryMenuItems.forEach((menuItem) => {
    menuItem.addEventListener('mouseenter', () => {
      secondaryMenuItems.forEach((item) => item.classList.remove('is-active'))
      menuItem.classList.add('is-active')
    })
  })

  headerSecondaryLinks?.addEventListener('mouseenter', () => {
    header?.classList.add('secondary-links-active')
  })

  headerSecondaryLinks?.addEventListener('mouseleave', () => {
    header?.classList.remove('secondary-links-active')
  })

  primaryMenuItems.forEach((menuItem) => {
    menuItem.addEventListener('mouseenter', () => activateMenuItem(menuItem))
    menuItem.addEventListener('mouseleave', handleMouseLeave)
  })

  window.addEventListener('resize', () => debounce(resetNavigation, 500))

  window.addEventListener('scroll', handleScroll)

  handleScroll()
  resetNavigation()
}
